var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-img-wrapper"},_vm._l((_vm.users),function(userItem,index){return _c('UserImg',{key:index,attrs:{"classKey":index,"userLimit":_vm.userLimit,"more-users-counter":_vm.moreUsers,"imageSrc":userItem.profileImage}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }